"use client";

import { useState } from "react";
import RichText from "./RichText";
import { cn } from "~/utils/cn";

export default function Accordion({
  title,
  description,
  defaultExpanded = false,
}: {
  title?: string | null;
  description?: string | null;
  defaultExpanded?: boolean | null;
}) {
  const [isOpen, setIsOpen] = useState(defaultExpanded);

  return (
    <div className="">
      <div className="flex">
        <h2 className=" flex-1 text-2xl text-gray-800">
          {title}
        </h2>
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className={cn(
            "material-icons-round h-fit rounded-sm bg-slate-50 p-3",
            isOpen && "rotate-180",
          )}
        >
          expand_more
        </button>
      </div>
      {isOpen && description && (
        <RichText field={description} className="my-3" />
      )}
    </div>
  );
}
